//#region src/common/enums.ts
/** To distinguish whether two rectangles are inside/intersecting/disconnected */
var ViewPort = /* @__PURE__ */ function(ViewPort) {
	ViewPort["INSIDE"] = "INSIDE";
	ViewPort["OUTSIDE"] = "OUTSIDE";
	ViewPort["INTERSECT"] = "INTERSECT";
	return ViewPort;
}({});
/** Levels of Detail, affects rendering while zooming in/out */
var LOD = /* @__PURE__ */ function(LOD) {
	LOD[LOD["LOD0"] = 0] = "LOD0";
	LOD[LOD["LOD1"] = 1] = "LOD1";
	LOD[LOD["LOD2"] = 2] = "LOD2";
	return LOD;
}({});
var Align = /* @__PURE__ */ function(Align) {
	Align[Align["Left"] = 0] = "Left";
	Align[Align["Center"] = 1] = "Center";
	Align[Align["Right"] = 2] = "Right";
	return Align;
}({});
var GlobalEventType = /* @__PURE__ */ function(GlobalEventType) {
	GlobalEventType[GlobalEventType["Emitter"] = 0] = "Emitter";
	GlobalEventType[GlobalEventType["Receiver"] = 1] = "Receiver";
	return GlobalEventType;
}({});
//#endregion
export { ViewPort as i, GlobalEventType as n, LOD as r, Align as t };

//# sourceMappingURL=enums-ArxA_qeI.js.map